import { render } from "./Text.vue?vue&type=template&id=9482b0cc&scoped=true&name=ModalText"
const script = {}

import "./Text.vue?vue&type=style&index=0&id=9482b0cc&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9482b0cc"]])

export default __exports__